import { EChartsOption } from "echarts";
import { Box, Container } from "@mui/material";
import { RopChart } from "../../../../main/components/RopChart";
import {
  numberPtBrCurrency,
  numberPtBrPercent01,
} from "../../../../main/utils/utils";
import { EmptyTable } from "../../../clients/components/EmptyState";

export default function ExpectedAndGeneratedValueChart(props: {
  valorGerado: number;
  valorEsperado: number;
}) {
  const { valorEsperado, valorGerado } = props;
  const valueRatio = (valorGerado ?? 0) / (valorEsperado ?? 0);
  const difference = valueRatio - 1;

  const options: EChartsOption = {
    title: {
      text: "Receita Real x Prevista",
      textStyle: {
        fontSize: 12,
      },
      subtext: "Receita obtida com a receita estimada para o período analisado",
      subtextStyle: {
        fontSize: 12,
        color: "#aaa",
      },
    },
    backgroundColor: "transparent",
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    series: [
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        center: ["50%", "65%"],
        radius: "100%",

        min: 0,
        max: 1,
        splitNumber: 3,

        axisLine: {
          lineStyle: {
            width: 35,
            color: [
              [0.49, "#ee7d00"], // Abaixo do centro
              [0.51, "#fade0a"], // Centro
              [1, "#fab900"], // Acima do centro
            ],
          },
        },

        pointer: {
          icon: "path://M12.8,0.7l12,40.1H0.7L12.8,0.7z",
          length: "55%",
          width: 15,
          offsetCenter: [0, "-35%"],
          itemStyle: {
            //color: 'auto'
            color: "#464646",
          },
        },

        axisTick: {
          show: false,
        },

        splitLine: {
          show: false,
        },

        axisLabel: {
          show: false,
        },

        tooltip: {
          show: true,
          valueFormatter: function (value: any) {
            return Number(value).toFixed(2);
          },
        },

        title: {
          offsetCenter: [0, "-15%"],
          fontSize: 16,
        },

        detail: {
          fontSize: 20,
          offsetCenter: [0, 0],
          formatter(v) {
            // Sempre mostra o sina de + ou -
            // e subtrai 0.5 para desconsiderar o deslocamento do centro
            const sign = v > 0.5 ? "+" : "";
            return `${sign}${numberPtBrPercent01(v - 0.5, 2)}`;
          },
          color: "inherit",
        },

        data: [
          {
            name: "% Previsto",
            value: 0.5 + difference, // Distância do centro
          },
        ],
      },
      {
        type: "gauge",
        startAngle: 180,
        endAngle: 0,
        center: ["50%", "75%"],
        radius: "100%",

        min: 0,
        max: 1,
        splitNumber: 3,

        axisLine: {
          show: false,
        },

        pointer: {
          show: false,
        },

        axisTick: {
          show: false,
        },

        splitLine: {
          show: false,
        },

        axisLabel: {
          show: false,
        },

        tooltip: {
          show: false,
        },

        title: {
          offsetCenter: [0, "-15%"],
          fontSize: 16,
        },
        detail: {
          formatter(v) {
            // Sempre mostra o sina de + ou -
            // e subtrai 0.5 para desconsiderar o deslocamento do centro
            return numberPtBrCurrency(v);
          },
          color: "inherit",
        },

        data: [
          {
            name: "Receita Real",
            value: valorGerado,
            title: {
              fontSize: 14,
              offsetCenter: ["40%", "15%"],
              color: "#FFF",
            },
            detail: {
              fontSize: 14,
              offsetCenter: ["40%", "30%"],
              color: "#FFF",
            },
          },
          {
            name: "Receita Precista",
            value: valorEsperado,
            title: {
              fontSize: 14,
              offsetCenter: ["-40%", "15%"],
              color: "#FFF",
            },
            detail: {
              fontSize: 14,
              offsetCenter: ["-40%", "30%"],
              color: "#FFF",
            },
          },
        ],
      },
    ],
  };

  const hasData = valorEsperado || valorGerado;

  return (
    <>
      {hasData ? (
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "90%",
            width: "100%",
          }}
        >
          <RopChart option={options} />
        </Container>
      ) : (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <EmptyTable title="Nenhum dado encontrado!" />
        </Box>
      )}
    </>
  );
}
